import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledSpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${spaceMixin(8)};
    height: ${({ height }) => (height || '200px')};
`;
